export default __webpack_public_path__ + "static/media/dog1.2f93d033.JPG";